<template>
  <div class="mainpage">
    <p class="mb-1">Select CTA type</p>
    <div class="d-flex justify-content-start mb-3">
      <div v-for="cta in ctaTypes" :key="cta.value" class="griditem">
        <div
          :class="[
            'ctaType',
            cta.value === currentCtaType ? 'ctaSelected' : '',
          ]"
          @click="changeCtaType(cta.value)"
        >
          <img class="mx-2" :src="cta.image" />
          <p class="ctaTypeText">{{ cta.label }}</p>
        </div>
      </div>
    </div>
    <div v-if="currentCtaType === 'url'" class="d-flex mb-3">
      <div class="d-flex align-items-center">
        <RadioButton
          v-model="subType"
          inputId="subType1"
          name="longurl"
          value="lu"
        />
        <label for="subType1" class="mx-2">Long URL</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <RadioButton
          v-model="subType"
          inputId="subType2"
          name="whatsapp"
          value="wp"
        />
        <label for="subType2" class="mx-2">Whatsapp Links</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <RadioButton
          v-model="subType"
          inputId="subType3"
          name="apk"
          value="apk"
        />
        <label for="subType3" class="mx-2">APK Links</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <RadioButton
          v-model="subType"
          inputId="subType3"
          name="short_domain"
          value="sd"
        />
        <label for="subType3" class="mx-2">Short domain</label>
      </div>
    </div>
    <div v-if="currentCtaType === 'mobile'" class="d-flex mb-3">
      <div class="d-flex align-items-center">
        <RadioButton
          v-model="subType"
          inputId="subType4"
          name="mobile"
          value="mob"
        />
        <label for="subType4" class="mx-2">Mobile</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <RadioButton
          v-model="subType"
          inputId="subType5"
          name="landline"
          value="ll"
        />
        <label for="subType5" class="mx-2">Landline</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <RadioButton
          v-model="subType"
          inputId="subType6"
          name="tollfree"
          value="tf"
        />
        <label for="subType6" class="mx-2">Toll free</label>
      </div>
      <div class="d-flex align-items-center mx-2">
        <RadioButton
          v-model="subType"
          inputId="subType6"
          name="shortcode"
          value="sc"
        />
        <label for="subType7" class="mx-2">Short code</label>
      </div>
    </div>
    <Form @submit="submitCta">
      <div v-if="currentCtaType === 'url'">
        <div v-if="subType !== 'sd'" class="input-fields">
          <label class="mb-1" for="static-url"
            >Enter URL
            <i
              class="pi pi-info-circle ml-1"
              v-tooltip="{
                value:
                  'URLs redirecting to a different domain will not be allowed',
                class: 'tooltip-class',
              }"
            ></i>
          </label>
          <Field
            name="longurl"
            :rules="isUrl"
            v-model="cta"
            v-slot="{ field, errors }"
          >
            <InputText
              type="text"
              v-bind="field"
              :placeholder="urlPlaceholder"
            />
            <span class="validation-error">{{ errors[0] }}</span>
          </Field>
        </div>
        <div v-if="subType === 'sd'">
          <div class="content">
            <div class="content__heading">Domain Details</div>
            <div class="d-flex mb-4 mt-4">
              <div class="d-flex align-items-center">
                <RadioButton
                  v-model="shortDomainType"
                  inputId="shortDomainType"
                  name="shortDomainType"
                  value="0"
                />
                <label for="shortDomainType" class="mx-2"
                  >Use Branded/Custom short domain</label
                >
              </div>
              <div class="d-flex align-items-center mx-2">
                <RadioButton
                  v-model="shortDomainType"
                  inputId="shortDomainType"
                  name="shortDomainType"
                  value="1"
                />
                <label for="shortDomainType" class="mx-2"
                  >Use {{ registeredDlt }} Short domain</label
                >
              </div>
            </div>
            <div class="input-group">
              <div class="input-fields">
                <label class="mb-1" for="protocol">Protocol</label>
                <Dropdown
                  v-if="shortDomainType === '0'"
                  style="width: 204px"
                  v-model="protocol"
                  :options="protocolOptions"
                  placeholder="Protocol"
                  optionLabel="label"
                  optionValue="value"
                />
                <InputText
                  v-else
                  :disabled="disableInput"
                  v-model="protocol"
                  placeholder="https"
                />
              </div>
              <div class="slash">://</div>
              <div class="input-fields">
                <label class="mb-1" for="short-domain">Short Domain</label>
                <Field
                  name="Short domain"
                  :rules="validateShortDomain"
                  v-model="shortDomain"
                  v-slot="{ field, errors }"
                >
                  <InputText
                    type="text"
                    v-bind="field"
                    placeholder="Short domain"
                    :disabled="disableInput"
                  />
                  <span class="validation-error">{{ errors[0] }}</span>
                </Field>
              </div>
              <div class="slash">/</div>
              <div class="input-fields">
                <label class="mb-1" for="protocol">Header</label>
                <Dropdown
                  style="width: 204px"
                  v-model="identifier"
                  :options="getIdentifiers"
                  filter
                  placeholder="Header"
                  optionLabel="name"
                  optionValue="name"
                />
              </div>
              <div class="slash">/</div>
              <div class="input-fields">
                <label class="mb-1" for="short-domain">Static / Dynamic</label>
                <InputText
                  type="text"
                  style="background-color: #eee"
                  disabled
                />
              </div>
            </div>
            <div class="content__footer">
              <div class="content__footer__info">
                You would be sending URLs as: {{ protocol }}{{ shortDomain
                }}{{ identifier !== "" ? "/" : "" }}{{ identifier }}
              </div>
              <div class="content__footer_rules">
                <div v-for="(item, idx) in whitelist_domain_rules" :key="idx">
                  {{ idx + 1 }}. {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="subType === 'lu'" class="actions-btns">
          <Checkbox inputId="isVariable" v-model="isVariable" :binary="true" />
          <label for="isVariable" class="mb-0 mx-2 cursor-pointer">
            Dynamic URL - URL contains variable. (Please enter only static part of the URL. For ex: https://yourbrand.com/path/?) in the above field
          </label>
        </div>
        <div v-if="isVariable" class="my-3 d-flex help-bg align-items-center">
          <i class="pi pi-info-circle info-btn mx-1"></i>
          <p class="mb-0 mx-1">
            "?" is mandatory for a dynamic URL and '/' will not be accepted in
            the dynamic part of URL
          </p>
        </div>
        <div v-if="isVariable" class="input-fields">
          <label class="mb-1" for="static-url">Sample URL</label>
          <Field
            name="sample"
            :rules="isDynamicUrl"
            v-model="sampleUrl"
            v-slot="{ field, errors }"
          >
            <InputText
              type="text"
              v-bind="field"
              placeholder="https://yourbrand.com/path/?productsku=1234"
            />
            <span class="validation-error">{{ errors[0] }}</span>
          </Field>
        </div>
        <div v-if="subscription" class="actions-btns">
          <Checkbox inputId="notShorten" v-model="notShorten" :binary="true" />
          <label for="notShorten" class="mb-0 mx-2 cursor-pointer">
            Do not shorten
          </label>
        </div>
      </div>
      <div v-else-if="currentCtaType === 'mobile'">
        <div class="input-fields">
          <label class="mb-1" for="static-url">Enter Number</label>
          <Field
            name="text"
            :rules="isNumber"
            v-model="cta"
            v-slot="{ field, errors }"
          >
            <InputText
              type="text"
              v-bind="field"
              :placeholder="mobileSubTypeMap[this.subType]['placeholder']"
            />
            <span class="validation-error">{{
              errors[0]
                ? `${mobileSubTypeMap[this.subType]["name"]} is not valid`
                : ""
            }}</span>
          </Field>
        </div>
      </div>
      <div v-else>
        <div class="input-fields">
          <label class="mb-1" for="static-url">Enter Email</label>
          <Field
            name="email"
            :rules="isEmail"
            v-model="cta"
            v-slot="{ field, errors }"
          >
            <InputText type="text" v-bind="field" placeholder="example@example.com" />
            <span class="validation-error">{{ errors[0] }}</span>
          </Field>
        </div>
      </div>
      <div class="actions-btns">
        <div class="gap">
          <Button type="submit" class="mr-3" label="Submit" />
        </div>
        <div>
          <Button label="Cancel" severity="secondary" @click="cancel" />
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
    mapModels,
    isValidURL,
    isValidMobileNumber,
    isValidLandline,
    isTollFree,
    isValidNumber,
    doesUrlhasParams,
    checkForIP,
    isValidShortCode,
    isValidAPKUrl
} from '@/utils'
import RadioButton from 'primevue/radiobutton'
import validator from 'validator'
import { CTA, protocolOptions } from '@/constants'
import Toastr from 'toastr'
import config from '@/config/config'

export default {
    name: 'Whitelist',
    components: {
        RadioButton
    },
    data () {
        return {
            protocolOptions,
            ctaTypes: [
                { label: 'URL', value: 'url', image: this.$images.whitelisting.url },
                {
                    label: 'Number',
                    value: 'mobile',
                    image: this.$images.whitelisting.mobile
                },
                {
                    label: 'Email',
                    value: 'email',
                    image: this.$images.whitelisting.email
                }
            ],
            currentCtaType: 'url',
            subType: 'lu',
            cta: '',
            sampleUrl: '',
            isVariable: false,
            notShorten: false,
            urlPlaceholder: 'https://google.com',
            mobileSubTypeMap: {
                ll: {
                    placeholder: '02488558869',
                    name: 'landline number'
                },
                mob: {
                    placeholder: '919603552539',
                    name: 'mobile number'
                },
                tf: {
                    placeholder: '180020213456',
                    name: 'tollfree number'
                },
                sc: {
                    placeholder: 'Enter number of length 3 to 7',
                    name: 'short code'
                }
            },
            shortDomain: '',
            identifier: '',
            whitelist_domain_rules: [
                'You can use your own Shortener or any public shorteners',
                'Header - Choose your header and send the same header in the URLs',
                'Text based on your shortening',
                'Example: bit.ly/brand1/loans - for static shortening ("loans" as custom back half) & bit.ly/brand1/abcdef - for Dynamic shortening (abcdef can be dynamically generated by your shortener)',
                'Http or Https is mandatory'
            ],
            shortDomainType: '0',
            disableInput: false,
            defaultDomain: config.DEFAULT_DOMAIN,
            protocol: 'https://',
            registeredDlt: config.REGISTERED_DLT
        }
    },
    methods: {
        isValidURL,
        cancel () {
            this.$router.push('/cta')
        },
        async submitCta () {
            const whatsappPattern = /^(https?:\/\/)(wa\.me|(chat\.|api\.|www\.)?whatsapp\.com)/
            if (this.currentCtaType === CTA.URL) {
                if (this.subType === 'sd') {
                    this.cta = this.protocol + this.shortDomain + '/' + this.identifier + '/'
                    if (
                        this.protocol === '' ||
            this.shortDomain === '' ||
            this.identifier === ''
                    ) {
                        Toastr.error('Domain', 'One or more Missing fields')
                        return
                    }
                }
                if (
                    this.cta.includes('{#var#}') ||
          this.sampleUrl.includes('{#var#}')
                ) {
                    Toastr.error(null, '{#var#} keyword is not allowed')
                    return
                }

                if (checkForIP(this.cta) || checkForIP(this.sampleUrl)) {
                    Toastr.error(null, 'IP addresses are not allowed')
                    return
                }

                if (!this.isVariable && this.cta[this.cta.length - 1] === '?') {
                    Toastr.error(null, "Static URL shouldn't have ? at end")
                    return
                }
                if (!this.isVariable && this.cta.includes('?')) {
                    Toastr.error(null, "Static URL shouldn't have '?' character")
                    return
                }

                if (this.isVariable && !doesUrlhasParams(this.sampleUrl)) {
                    Toastr.error(null, 'Improper query params at end of sample url')
                    return
                }

                if (this.isVariable && !this.sampleUrl.startsWith(this.cta)) {
                    Toastr.error(null, 'Sample URL not matches with URL')
                    return
                }
                if (this.subType === 'wp' && !whatsappPattern.test(this.cta)) {
                    Toastr.error(null, 'Please enter a valid whatsapp URL')
                    return
                }
                if (this.subType === 'apk' && !isValidAPKUrl(this.cta)) {
                    Toastr.error(null, 'Please enter a valid APK URL')
                    return
                }
            }
            const data = {
                type: this.currentCtaType,
                sub_type: this.subType,
                cta: this.cta.toString(),
                sample_cta: this.sampleUrl,
                has_variables: this.isVariable,
                not_shorten: this.notShorten,
                status: 1,
                short_domain:
          this.subType === 'sd' ? this.protocol + this.shortDomain : '',
                identifier: this.identifier
            }
            this.globalLoader = true
            const resp = await this.$store.dispatch('Cta/Whitelist/whitelist', data)
            if (resp) {
                this.$router.push('/cta')
            }
            this.globalLoader = false
        },

        async changeCtaType (value) {
            if (value !== this.currentCtaType) {
                if (value === 'mobile') {
                    this.currentCtaType = value
                    this.subType = 'mob'
                    this.cta = ''
                } else if (value === 'url') {
                    this.currentCtaType = value
                    this.subType = 'lu'
                    this.cta = ''
                } else if (value === 'email') {
                    this.currentCtaType = value
                    this.subType = 'email'
                    this.cta = ''
                }
                this.isVariable = false
                this.notShorten = false
                this.sampleUrl = ''
            }
        },
        isDynamicUrl (value) {
            if (!(value.startsWith('http://') || value.startsWith('https://') || value.startsWith('www.'))) {
                return 'URL should start with https or http or www'
            }
            if (!value) {
                return 'This is a required field'
            }
            let test = isValidURL(value)
            if (!test) {
                return 'Please enter a valid URL'
            }
            return true
        },
        isEmail (value) {
            return validator.isEmail(value)
        },
        isUrl (value) {
            if (!value) {
                return 'This is a required field'
            }
            if (['lu', 'apk'].includes(this.subType) && value && !(value.startsWith('http://') || value.startsWith('https://') || value.startsWith('www.'))) {
                return 'CTA should start with either https:// or http:// or www.'
            } else if (['wp', 'sd'].includes(this.subType) && value && !(value.startsWith('http://') || value.startsWith('https://'))) {
                return 'CTA should start with either https:// or http://'
            }

            let test = isValidURL(value)
            if (!test) {
                return 'Please enter a valid URL'
            } else if (this.isVariable && value[value.length - 1] !== '?') {
                return 'Dynamic URL should have ? at end'
            }
            return true
        },
        isNumber (value) {
            if (!value) {
                return 'This is a required field'
            }
            if (this.subType === 'mob') {
                return isValidMobileNumber(value)
            } else if (this.subType === 'll') {
                return isValidLandline(value)
            } else if (this.subType === 'tf') {
                return isTollFree(value)
            } else if (this.subType === 'sc') {
                return isValidShortCode(value)
            } else {
                return isValidNumber(value)
            }
        },
        validateShortDomain (value) {
            if (value === '') return false
            else if (value.startsWith('https://') || value.startsWith('http://')) {
                return 'protocol is not required'
            } else if (value.includes('/')) {
                return "'/' not allowed in the domain"
            }
            return true
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapModels('general', ['globalLoader', 'subscription']),
        ...mapGetters('Cta/Whitelist', ['getIdentifiers'])
    },
    async beforeMount () {
        await this.$store.dispatch('Cta/Whitelist/fetchIdentifiers')
    },
    watch: {
        subType (newValue) {
            this.cta = ''
            this.sample_cta = ''
            this.isVariable = false
            if (newValue === 'wp') {
                this.urlPlaceholder = 'https://wa.me/91xxxxxxxxxx'
            } else if (newValue === 'apk') {
                this.urlPlaceholder = 'https://dw.uptodown.net/dwn/instagram-349-3-0-42-104.apk'
            } else {
                this.urlPlaceholder = 'https://www.google.com'
            }
        },
        shortDomainType (newValue) {
            if (newValue === '1') {
                this.shortDomain = this.defaultDomain
                this.disableInput = true
                this.protocol = 'https://'
            } else {
                this.shortDomain = ''
                this.disableInput = false
                this.protocol = 'https://'
            }
        },
        isVariable () {
            this.sampleUrl = ''
        }
    }
}
</script>

<style>
.ctaType {
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 150px;
  height: 50px;
  padding: 5px 2px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 0.5rem;
}
.ctaSelected {
  border: 1px solid black;
}
.ctaTypeText {
  text-align: center;
  color: black;
  font-size: 0.875rem;
  font-weight: 800;
  line-height: 1rem;
  margin: 0px;
}
.ctaType:hover {
  border: 1px solid black;
}
.input-fields {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
.actions-btns {
  margin-bottom: 1rem;
  display: flex;
  justify-content: start;
}
.info-btn {
  color: var(--primary-color);
}
.tooltip-class {
  width: initial !important;
  min-width: 400px;
}
.slash {
  padding: 30px 10px;
}
.content__footer {
  display: flex;
  flex-direction: column;
  gap: 2em;
}
.content__footer__info {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}
</style>
